const CODE_SITE_SEARCH_HIDDEN_PATH_PREFIXES = [
  '/admin/droits/groupe',
  '/admin/droits/utilisateur',
  '/admin/config-inventaire/essences',
  '/admin/config-inventaire/champignons',
  '/admin/bibliotheque/essences',
  '/admin/bibliotheque/champignons',
  '/admin/droits/profil',
  '/admin/droits/creation-rapide',
  '/admin/config-inventaire/essences',
  '/admin/contacts',
  '/admin/promo-codes',
  // Espace superadmin : réglages plateforme, pas de recherche par code site.
  '/superadmin'
] as const;

/**
 * Returns true when the global code_site search should be shown in the header.
 */
export function shouldShowCodeSiteSearch(pathname: string): boolean {
  return !CODE_SITE_SEARCH_HIDDEN_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix)
  );
}
